/* ============================================================
   TFS v41 - CORRECTIFS FONCTIONNELS
   Charge en DERNIER, apres theme.js et tous les overlays.
   ============================================================ */
(function () {
  'use strict';

  /* 1. LE PIEGE DE LA PRECOMMANDE (bloquant)
     theme.js -> updateOptionAvailability() desactive chaque radio
     de taille dont aucune variante n'est available. En precommande
     une variante peut etre indisponible au sens Shopify tout en
     restant commandable : tout le reste du theme le sait (le badge
     dit Precommande, jamais Epuise), sauf cette fonction.
     Consequence : toutes les tailles grisees, le bouton affiche
     Choisir une taille, et aucun clic ne peut le satisfaire. */
  function preorderOn(root) {
    if (!root) return false;
    var node = root.querySelector('[data-product-json]');
    if (!node) return false;
    try {
      return JSON.parse(node.textContent).preorder === true;
    } catch (e) {
      return false;
    }
  }

  function unlockOptions(root) {
    var inputs = root.querySelectorAll('[data-option-index] input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].disabled) {
        inputs[i].disabled = false;
        if (inputs[i].parentElement) {
          inputs[i].parentElement.classList.remove('is-unavailable');
        }
      }
    }
  }

  function guardPreorder() {
    var roots = document.querySelectorAll('[data-product-root]');
    for (var i = 0; i < roots.length; i++) {
      (function (root) {
        if (!preorderOn(root)) return;
        unlockOptions(root);
        root.addEventListener('change', function () {
          window.setTimeout(function () { unlockOptions(root); }, 0);
        }, true);
        new MutationObserver(function () { unlockOptions(root); }).observe(root, {
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled']
        });
      })(roots[i]);
    }
  }

  /* 2. LE VOILE NOIR QUI RESTE (bloquant)
     theme.js -> closeOverlay() ne touche jamais
     [data-cart-backdrop]. Seul closeCart() le masque. Fermer le
     tiroir avec Echap, ou ouvrir le menu par-dessus le tiroir,
     passe par closeOverlay() : le tiroir disparait mais le voile
     plein ecran (z-index 240) reste et avale tous les clics. */
  function guardBackdrop() {
    var backdrop = document.querySelector('[data-cart-backdrop]');
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!backdrop || !drawer) return;

    function drawerOpen() {
      return drawer.getAttribute('aria-hidden') === 'false' && !drawer.hidden;
    }

    new MutationObserver(function () {
      if (drawerOpen() || backdrop.hidden) return;
      window.setTimeout(function () {
        if (!drawerOpen()) backdrop.hidden = true;
      }, 380);
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden', 'hidden'] });

    backdrop.addEventListener('click', function () {
      backdrop.hidden = true;
      document.body.classList.remove('drawer-open', 'menu-open');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      window.setTimeout(function () {
        if (!drawerOpen()) backdrop.hidden = true;
      }, 400);
    });
  }

  /* 3. LE FORMAT DES PRIX
     La langue principale de la boutique est l'anglais alors que
     tout le contenu est francais. theme.js formate les prix avec
     Intl.NumberFormat(TFS.locale), donc en : le tiroir affiche
     EUR 49.00 pendant que /cart affiche 49,00 EUR. */
  function fixMoneyLocale() {
    if (window.TFS && (window.TFS.locale === 'en' || !window.TFS.locale)) {
      window.TFS.locale = 'fr-BE';
    }
  }

  /* 4. LE GUIDE DES TAILLES QUI NE S'OUVRE PAS
     Le lien Guide des tailles pointe sur #pdp-size-guide, un
     <details> ferme. Un fragment n'ouvre pas un <details>. */
  function openAnchoredDetails() {
    function open(hash) {
      if (!hash || hash.length < 2) return;
      var el;
      try { el = document.querySelector(hash); } catch (e) { return; }
      if (el && el.tagName === 'DETAILS') {
        el.open = true;
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      window.setTimeout(function () { open(a.getAttribute('href')); }, 0);
    });
    if (location.hash) window.setTimeout(function () { open(location.hash); }, 300);
  }

  /* 5. LE DOUBLE SAUT DE PAGE AU CHOIX D'UNE TAILLE
     theme.js -> updateVariant() appelle scrollIntoView sur la
     media de la variante, de facon synchrone dans l'evenement
     change. tfs-v23 fait le sien 60 ms plus tard, en evitant de
     bouger la page sur telephone. On ne neutralise que le premier,
     dans une fenetre de 40 ms et uniquement dans la galerie. */
  function suppressDoubleScroll() {
    if (!document.querySelector('[data-product-root]')) return;
    var guardUntil = 0;
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-option-index]')) {
        guardUntil = Date.now() + 40;
      }
    }, true);

    var native = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () {
      if (Date.now() < guardUntil && this.closest && this.closest('.product-gallery')) return;
      return native.apply(this, arguments);
    };
  }

  /* 6. LE BOUTON QUI SE REACTIVE PENDANT SA PROPRE REQUETE
     tfs-v37 desactive le bouton puis lance /cart/add.js, mais son
     MutationObserver retire disabled a la micro-tache suivante,
     avant la reponse. Le bouton affiche Ajout... tout en etant
     cliquable : sur une connexion lente, un deuxieme appui
     declenche une deuxieme commande.

     IMPORTANT : ce garde s'arme AVANT tfs-v37 (ecouteur en capture
     sur document, donc avant l'ecouteur au niveau du bouton). Il
     ne doit donc PAS s'armer quand v37 va de toute facon refuser
     le clic faute de taille choisie — sinon on grise le bouton
     1,8 s juste apres avoir dit au client de choisir sa taille. */
  function everyOptionChosen(btn) {
    var root = btn.closest ? btn.closest('[data-product-root]') : null;
    if (!root) root = document.querySelector('[data-product-root]');
    if (!root) return true;
    var groups = root.querySelectorAll('[data-option-index]');
    for (var i = 0; i < groups.length; i++) {
      if (!groups[i].querySelector('input:checked')) return false;
    }
    return true;
  }

  function guardDoubleSubmit() {
    var busy = false;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest
        ? e.target.closest('[data-add-to-cart], [data-sticky-submit]')
        : null;
      if (!btn) return;
      if (busy) {
        e.preventDefault();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        return;
      }
      if (!everyOptionChosen(btn)) return;
      busy = true;
      btn.setAttribute('aria-busy', 'true');
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '.6';
      window.setTimeout(function () {
        busy = false;
        btn.removeAttribute('aria-busy');
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
      }, 1800);
    }, true);
  }

  /* 7. L'ETAT aria-busy QUI NE SE LIBERE JAMAIS
     theme.js -> changeCartLine() pose aria-busy=true sur la liste
     et ne le retire que dans refreshCart(). Sur le chemin
     d'erreur, refreshCart n'est jamais atteint. */
  function guardAriaBusy() {
    var lines = document.querySelector('[data-cart-lines]');
    if (!lines) return;
    new MutationObserver(function () {
      if (lines.getAttribute('aria-busy') !== 'true') return;
      window.setTimeout(function () {
        if (lines.getAttribute('aria-busy') === 'true') {
          lines.setAttribute('aria-busy', 'false');
        }
      }, 6000);
    }).observe(lines, { attributes: true, attributeFilter: ['aria-busy'] });
  }

  /* 8. aria-expanded RESTE A TRUE
     tfs-v40 retire aria-controls des declencheurs de panier. Mais
     theme.js retrouve le declencheur PAR aria-controls pour
     remettre aria-expanded a false : plus rien ne le remet a jour
     sur les boutons d'ajout rapide des cartes produit. */
  function guardAriaExpanded() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    new MutationObserver(function () {
      var open = drawer.getAttribute('aria-hidden') === 'false' && !drawer.hidden;
      if (open) return;
      var stale = document.querySelectorAll('[data-quick-add] [aria-expanded="true"]');
      for (var i = 0; i < stale.length; i++) {
        stale[i].setAttribute('aria-expanded', 'false');
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden', 'hidden'] });
  }

  function boot() {
    try { fixMoneyLocale(); } catch (e) {}
    try { guardPreorder(); } catch (e) {}
    try { guardBackdrop(); } catch (e) {}
    try { openAnchoredDetails(); } catch (e) {}
    try { suppressDoubleScroll(); } catch (e) {}
    try { guardDoubleSubmit(); } catch (e) {}
    try { guardAriaBusy(); } catch (e) {}
    try { guardAriaExpanded(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.setTimeout(boot, 0); });
  } else {
    window.setTimeout(boot, 0);
  }
})();
